module.exports = __webpack_public_path__ + "img/c06_unitcaravan_Normal_ua.a9dd0691.webp";